<template>
    <div v-if="nodes && nodes.length" class="mb-8">
        <h3 v-if="title" class="text-xl font-semibold capitalize mb-4">{{ title }}</h3>

        <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            <router-link v-for="node in nodes" :key="node.id"
                :to="node.children && node.children.length
                    ? { name: 'frontend.categories.children', params: { slug: node.slug } }
                    : { name: 'frontend.product', query: { category: node.slug } }"
                class="group border rounded-xl overflow-hidden bg-white hover:border-primary transition-all duration-300">
                <img :src="node.cover || node.thumb" :alt="node.name" class="w-full h-32 object-cover">
                <div class="p-3">
                    <p class="text-sm font-medium capitalize group-hover:text-primary transition-all duration-300">{{ node.name }}</p>
                </div>
            </router-link>
        </div>

        <div v-for="node in nodes" :key="`children-${node.id}`" class="mt-6">
            <CategoryRecursiveGridComponent
                v-if="node.children && node.children.length"
                :nodes="node.children"
                :title="node.name" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'CategoryRecursiveGridComponent',
    props: {
        nodes: {
            type: Array,
            default: () => []
        },
        title: {
            type: String,
            default: ''
        }
    }
}
</script>
